import type { TeamEventsDirection } from '@/types/team'
import type { PlayerStat } from '@/types/standings'

export const QUERY_KEYS = {
  profile: ['profile'] as const,
  cinematics: (tag: string) => ['cinematics', tag] as const,
  activeOrders: ['orders', 'active'] as const,
  // Prefix. `useOrders` builds its key as `[...ordersAll, filterBy]`, so
  // invalidating this covers every filter variant at once.
  ordersAll: ['orders', 'all'] as const,
  // The `'doc'` segment keeps the single-team document apart from the
  // `['team', 'detail', …]` and `['team', 'events', …]` caches below.
  teamDoc: (idTeam: string) => ['team', 'doc', idTeam] as const,
  team: (idTeam: string, params: { itemsPerPage: number; idTournament?: string }) =>
    ['team', 'detail', idTeam, params] as const,
  teamEvents: (idTeam: string, direction: TeamEventsDirection, itemsPerPage: number) =>
    ['team', 'events', idTeam, direction, itemsPerPage] as const,
  tournamentTeams: (idTournament: string) => ['tournamentTeams', idTournament] as const,
  // Prefix. The scoped key below builds on the same literal, so invalidating
  // this covers every tab — and the season segment the key will grow once the
  // `params` is spread conditionally by the caller: an omitted `tab` (the first
  // request, which lets the backend resolve its own default) must not become a
  // `tab` is omitted from the params when the active tab is the default one, so
  // the unscoped first request and the default tab share a single cache entry.
  standings: (idTournament: string, params: { tab?: string }) =>
    ['standings', idTournament, params] as const,
  playerStats: (idTournament: string, params: { stat: PlayerStat; stage?: string }) =>
    ['playerStats', idTournament, params] as const,
  eventDetail: (id: string) => ['event-details', id] as const,
  // Prefix invalidation (billingInfoPrefix) must hit every scoped entry —
  // keep the scoped key building on the same literal.
  billingInfoPrefix: ['billingInfo'] as const,
  billingInfo: (gatewayIntegrator?: string, collectionType?: string) =>
    ['billingInfo', gatewayIntegrator, collectionType] as const,
  feedbackOptions: ['feedback', 'options'] as const,
} as const
